export default __webpack_public_path__ + "static/media/information-primary.1e0e0123.svg";